export default "__VITE_ASSET__C_AF3ix3__"